module.exports = __webpack_public_path__ + "static/img/1_7_1.34b2f4bd.jpg";